module.exports = __webpack_public_path__ + "static/media/PZ.626115dd.png";